(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cheat-code-preview-links"] && !Shopify.designMode) return;
  try {
    (() => {
    const allowedViews = new Set(['cheat-code-job-loss','cheat-code-self-employed-sickness','cheat-code-scam-non-delivery','cheat-code-new-parent','cheat-code-scan']);
    function preparePreviewLinks() {
      const current = new URL(window.location.href);
      const themeId = String(window.Shopify?.theme?.id || current.searchParams.get('preview_theme_id') || '');
      if (themeId !== '206959575379') return;
      document.querySelectorAll('a[data-cc-preview-link]').forEach(link => {
        const target = new URL(link.getAttribute('href'), window.location.href);
        if (target.origin !== current.origin || !allowedViews.has(target.searchParams.get('view'))) return;
        target.searchParams.set('preview_theme_id','206959575379');
        link.setAttribute('href',target.pathname + target.search + target.hash);
      });
    }
    preparePreviewLinks();
    document.addEventListener('shopify:section:load',preparePreviewLinks);
  })();
  } catch(e) { console.error(e); }
})();

})();
